(function () {
  function stopItem(item) {
    var player = item.querySelector('[data-video-gallery-player]');

    if (player) {
      var video = player.querySelector('video');

      if (video) {
        try {
          video.pause();
        } catch (e) {}
      }

      player.innerHTML = '';
    }

    item.classList.remove('is-playing');
  }

  function startPlayback(video, showControls) {
    if (!video) {
      return;
    }

    video.setAttribute('playsinline', '');
    video.playsInline = true;
    video.controls = showControls;

    var attempt = video.play();

    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Autoplay with sound can be blocked; fall back to muted playback.
        video.muted = true;
        var retry = video.play();

        if (retry && typeof retry.catch === 'function') {
          retry.catch(function () {});
        }
      });
    }
  }

  function playItem(gallery, item) {
    var template = item.querySelector('[data-video-gallery-template]');
    var player = item.querySelector('[data-video-gallery-player]');

    if (!template || !player) {
      return;
    }

    // Stop any other video already playing in this gallery.
    gallery.querySelectorAll('[data-video-gallery-item].is-playing').forEach(function (other) {
      if (other !== item) {
        stopItem(other);
      }
    });

    if (item.classList.contains('is-playing')) {
      return;
    }

    player.innerHTML = '';
    player.appendChild(template.content.cloneNode(true));
    item.classList.add('is-playing');

    var showControls = gallery.getAttribute('data-video-controls') !== 'false';

    startPlayback(player.querySelector('video'), showControls);
  }

  function startAutoplayItem(item) {
    var template = item.querySelector('[data-video-gallery-template]');
    var player = item.querySelector('[data-video-gallery-player]');

    if (!template || !player || item.classList.contains('is-playing')) {
      return;
    }

    player.innerHTML = '';
    player.appendChild(template.content.cloneNode(true));
    item.classList.add('is-playing');

    var video = player.querySelector('video');

    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      var attempt = video.play();

      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {});
      }
    }
  }

  function initAutoplay(gallery) {
    if (gallery.getAttribute('data-video-autoplay') !== 'true' || gallery.dataset.vgAutoplayBound) {
      return;
    }

    gallery.dataset.vgAutoplayBound = 'true';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAutoplayItem(entry.target);
          } else {
            stopItem(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px 100px 0px', threshold: 0.25 }
    );

    gallery.querySelectorAll('[data-video-gallery-item]').forEach(function (item) {
      observer.observe(item);
    });
  }

  function init(root) {
    root.querySelectorAll('[data-product-video-gallery]').forEach(function (gallery) {
      initAutoplay(gallery);

      if (gallery.dataset.vgBound) {
        return;
      }

      gallery.dataset.vgBound = 'true';

      gallery.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-video-gallery-trigger]');

        if (!trigger || !gallery.contains(trigger)) {
          return;
        }

        event.preventDefault();

        var item = trigger.closest('[data-video-gallery-item]');

        if (item) {
          playItem(gallery, item);
        }
      });
    });
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();